// Shared by the SDK config (tracking.ts) and the first-party proxy (mixpanelProxy.js).
// Blocker filter lists match Mixpanel's own paths ("/track/?verbose=1&ip=1", "/mp/..."),
// so the browser only ever sees these neutral names and the proxy maps them back.
export const MIXPANEL_PROXY_PREFIX = '/ca';

// SDK api_routes key -> [alias the browser uses, real Mixpanel route]
export const MIXPANEL_PROXY_ROUTES = {
  track: ['e/', 'track/'],
  engage: ['p/', 'engage/'],
  groups: ['g/', 'groups/'],
  record: ['r/', 'record/'],
  flags: ['f/', 'flags/'],
  settings: ['s/', 'settings/'],
} as const;

type RouteKey = keyof typeof MIXPANEL_PROXY_ROUTES;

/** api_routes for mixpanel.init when going through the proxy (the SDK replaces, not merges). */
export const proxiedApiRoutes = (): Record<RouteKey, string> =>
  Object.fromEntries(
    Object.entries(MIXPANEL_PROXY_ROUTES).map(([key, [alias]]) => [key, alias]),
  ) as Record<RouteKey, string>;

/** Real Mixpanel route for an alias, e.g. "e/" -> "track/". */
export const upstreamRouteFor = (alias: string): string | undefined =>
  Object.values(MIXPANEL_PROXY_ROUTES).find(([a]) => a === alias)?.[1];
